import { useBoundStore } from '@Store/index.ts';
import { RoutesMap } from './router.types';
import { updateNavStack } from './useSendNavStack';
import { _getPageIndex, _handleUnAuthorized } from './routesUtil/RoutesUtil';

export const isCustomerAuth = (): boolean => {
  const { accessToken } = useBoundStore.getState().customer;
  return !!accessToken;
};
export interface IBeforeLoadGeneral {
  page: RoutesMap;
  shouldUpdateServerNavStack: boolean;
  force?: boolean;
  shouldAvoidAuthCheck?: boolean;
  stepToReturn?: RoutesMap;
}

export const beforeLoadGeneral = ({
  page,
  shouldUpdateServerNavStack,
  force,
  shouldAvoidAuthCheck,
  stepToReturn,
}: IBeforeLoadGeneral): void => {
  const setCurrentPageIndex = useBoundStore.getState().onboardingSlice.setCurrentPageIndex;

  if (!isCustomerAuth() && !shouldAvoidAuthCheck) {
    _handleUnAuthorized();
    return;
  }
  if (!setCurrentPageIndex) return;

  if (shouldUpdateServerNavStack) {
    updateNavStack({ currentPage: page, force, stepToReturn: stepToReturn });
  }
  setCurrentPageIndex(_getPageIndex(page));
};
